import { FC } from 'react';
import { useRouteMatch, Switch, Route, Redirect } from 'react-router-dom';
// Store
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectConversation } from 'app/store/AIChat/AIChat.selectors';
// Mui
import { Box } from '@mui/material';
// Hooks
import useAiChatPermissionResolver from 'app/hooks/useAiChatPermissionResolver';
import useCasePermissionResolved from 'app/hooks/useCasePermissionResolver';
// 
import ConversationInitialRoute from './ConversationInitialRoute';
// import ConversationMessageList from './ConversationMessageList';
import MessageListItems from './MessageListItems';
import ChatMessageForm from './ChatMessageForm';
// import ConversationMessageForm from './ConversationMessageForm';

const AIChatRoutes:FC = () => {
  const { path } = useRouteMatch<{ path:string; }>();

  // State
  const conversation = useAppSelector(selectConversation);

  const { caseAIChatEnabled, isCaseProcessingReadyOrNotStarted } = useCasePermissionResolved();
  const { allowModifications, createdAutomatically } = useAiChatPermissionResolver();

  const isEditableIfNotAutoCreated = allowModifications && !createdAutomatically;
  const isNonConversationOrEditableSelected = !conversation || isEditableIfNotAutoCreated;

  const showConversationForm = caseAIChatEnabled && isCaseProcessingReadyOrNotStarted && isNonConversationOrEditableSelected;

  return (
    <Box sx={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      overflowY: 'auto'
    }}>
      <Switch>
        <Route exact path={path} component={ConversationInitialRoute} />
        <Route path={`${path}/:conversationId`} component={ChatDetailsPage} />
      </Switch>
      {showConversationForm ? (
        <ChatMessageForm />
      ) : null}
    </Box>
  )
}

export default AIChatRoutes;

const ChatDetailsPage = () => {
  const { url } = useRouteMatch<{ url:string }>();
  const { caseAIChatEnabled } = useCasePermissionResolved();
  if ( !caseAIChatEnabled ) return <Redirect to={url} />;
  return <MessageListItems />;
}
